import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, useForm} from "@inertiajs/inertia-react";
import LoadingButton from "@/Shared/LoadingButton";
import BannerForm from "@/Pages/Banners/Assets/BannerForm";

const Create = () => {
  const {data, setData, errors, post, processing} = useForm({
    url: '',
    image: '',
    mob_image: '',
    showonline: false,
    banner_name: '',
    expire_date: ''
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('banners.store').url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('banners')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Banners
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <BannerForm errors={errors} data={data} setData={setData}/>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Create Banner
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Create.layout = page => <Layout title="Create banner" children={page}/>;

export default Create;

